var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.125,
    height: 19.718,
    viewBox: "0 0 15.125 19.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "diary_3_",
    "data-name": "diary (3)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M41.781,18.623H41.65v-.464a.909.909,0,1,0-1.818,0v.464H38.618v-.464a.909.909,0,1,0-1.818,0v.464H35.585v-.464a.909.909,0,1,0-1.818,0v.464H32.553v-.464a.909.909,0,1,0-1.818,0v.464H30.6A1.976,1.976,0,0,0,28.63,20.6v14.4A1.976,1.976,0,0,0,30.6,36.968H41.781a1.976,1.976,0,0,0,1.974-1.974V20.6A1.976,1.976,0,0,0,41.781,18.623Zm-1.211-.464a.171.171,0,0,1,.171-.171.167.167,0,0,1,.118.047.179.179,0,0,1,.053.123v1.594a.169.169,0,0,1-.171.171.171.171,0,0,1-.171-.171Zm-3.033,0a.171.171,0,0,1,.171-.171.169.169,0,0,1,.118.047.178.178,0,0,1,.053.123v1.594a.169.169,0,0,1-.171.171.171.171,0,0,1-.171-.171Zm-3.033,0a.171.171,0,0,1,.171-.171.167.167,0,0,1,.118.047.178.178,0,0,1,.053.123v1.594a.171.171,0,0,1-.171.171.169.169,0,0,1-.171-.171Zm-3.033,0a.171.171,0,0,1,.171-.171.167.167,0,0,1,.118.047.178.178,0,0,1,.053.123v1.594a.171.171,0,0,1-.171.171.169.169,0,0,1-.171-.171ZM43.017,34.994a1.237,1.237,0,0,1-1.236,1.236H30.6a1.237,1.237,0,0,1-1.236-1.236V20.6A1.237,1.237,0,0,1,30.6,19.361h.131v.392a.909.909,0,1,0,1.818,0v-.392h1.215v.392a.909.909,0,1,0,1.818,0v-.392H36.8v.392a.909.909,0,1,0,1.818,0v-.392h1.215v.392a.909.909,0,1,0,1.818,0v-.392h.131A1.237,1.237,0,0,1,43.017,20.6Z",
    transform: "translate(-28.63 -17.25)",
    fill: "#86FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M50.44,42.954H41.2a.369.369,0,0,0,0,.738H50.44a.369.369,0,1,0,0-.738Z",
    transform: "translate(-38.257 -37.533)",
    fill: "#86FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M50.44,57.988H41.2a.369.369,0,0,0,0,.738H50.44a.369.369,0,1,0,0-.738Z",
    transform: "translate(-38.257 -49.397)",
    fill: "#86FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M50.369,73.022H41.2a.369.369,0,0,0,0,.738h9.17a.369.369,0,1,0,0-.738Z",
    transform: "translate(-38.257 -61.26)",
    fill: "#86FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M50.369,88.057H41.2a.369.369,0,1,0,0,.738h9.17a.369.369,0,1,0,0-.738Z",
    transform: "translate(-38.257 -73.124)",
    fill: "#86FFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiary);
export default __webpack_public_path__ + "static/media/diary.ff1caa5d5f1e1b29b0c0682c823f8a43.svg";
export { ForwardRef as ReactComponent };